import { DispensariesPageEntry } from 'src/dispensaries/dispensaries-page-entry';
import { MainLayout } from 'components/layouts/main-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(DispensariesPageEntry, MainLayout);
